import { connect } from 'react-redux';
import { State } from 'widgets/redeem/root/root.reducers';
import Success from './success.component';

const mapStateToProps = (state: State) => ({
    widgetName: state.config.widgetName
});

const SuccessContainer = connect(mapStateToProps)(Success);
export default SuccessContainer;
